<template>
  <div class="container">
    <div class="row">
      <div class="col-12 col-md-8 mx-auto">
        <div class="modal-content border-0 shadow">
          <div class="modal-header pb-0 border-0">
            <div class="col-12">
              <button
                type="button"
                class="btn btn-block d-flex ms-auto"
                style="left: 0; top: 0"
                @click="close"
              >
                <v-icon
                  icon="times"
                  width="20"
                  height="20"
                />
              </button>
            </div>
          </div>
          <div class="modal-body pb-5">
            <div class="col-12 col-md-9 mx-auto">
              <div class="d-flex mx-auto">
                <img
                  :src="`${aws}/unicorn-feather.png`"
                  class="mx-auto mb-3"
                >
              </div>
            </div>
            <div class="col-12 col-md-9 mx-auto">
              <div>
                Ce document n'est pas encore disponible en ligne.
                Veuillez contacter notre équipe Gestion afin d'obtenir
                votre attestation
              </div>
              <v-loader
                title="Contacter directement"
                icon="arrow-white-right"
                :next="closeAndOpenIntercom"
                class="w-100 mt-3"
              />
              <v-loader
                title="Envoyer un e-mail"
                color="blue-300"
                icon="email-white"
                :next="closeAndOpenEmail"
                class="w-100 mt-1"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { ui } from '@/mixins';

export default {
  mixins: [ui],
  computed: {
    ...mapGetters({
      contract: 'contract/get',
    }),
    aws: () => `${import.meta.env.VITE_AWS_STATIC}/common/png`,
  },
  methods: {
    close() { return this.ui_showModal(false) },
    closeAndOpenIntercom() {
      this.close();
      return this.$store.dispatch('intercom/openMessenger');
    },
    closeAndOpenEmail() {
      this.close();
      window.open('mailto:gestion@assurup.com');
      return Promise.resolve();
    },
  },
};
</script>
